/**
 * Sentry Session Replay — consent-gated.
 *
 * The replay integration is created here and registered in Sentry.init()
 * (src/main.tsx), but recording does NOT start automatically — the init
 * sample rates are 0. `setReplayEnabled` is driven by CookieConsentContext,
 * so replays are only recorded after the user grants analytics cookie
 * consent, mirroring how PostHog opt-in is gated.
 *
 * Privacy: form inputs (prompts, emails) are masked and all media is blocked,
 * so user-typed text and uploaded photos never appear in a replay. UI text
 * stays visible so replays remain useful for debugging.
 */

import * as Sentry from "@sentry/react";

export const sentryReplay = Sentry.replayIntegration({
  maskAllText: false,
  maskAllInputs: true,
  blockAllMedia: true,
});

/**
 * Start (buffered — flushed when an error occurs) or stop replay recording.
 * No-op when Sentry is disabled (no DSN) or the integration is not ready.
 */
export function setReplayEnabled(enabled: boolean): void {
  if (!Sentry.getClient()) return;
  try {
    if (enabled) {
      sentryReplay.startBuffering();
    } else {
      sentryReplay.stop().catch(() => {
        /* not recording — ignore */
      });
    }
  } catch {
    /* Replay integration not ready — ignore. */
  }
}
